import React from "react";

const ParcenalCenter = () => {
  return (
    <div
      style={{
        padding: "20px",
        maxWidth: "800px",
        margin: "20px auto",
        backgroundColor: "#222",
        borderRadius: "12px",
        boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
        color: "#fff",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h2 style={{ textAlign: "center", color: "#4caf50" }}>
        👤 Parcenal Center
      </h2>

      <p style={{ lineHeight: "1.8", fontSize: "16px", marginTop: "10px" }}>
        Hii ni <strong>sehemu yako binafsi</strong> ya kufuatilia safari yako
        ndani ya <strong>FES</strong>. 🏆
      </p>

      {/* Info cards */}
      <div style={{ display: "grid", gap: "15px", marginTop: "20px" }}>
        <div style={{
          background: "#333", padding: "15px", borderRadius: "8px",
          boxShadow: "0 3px 6px rgba(0,0,0,0.3)"
        }}>
          📌 Akaunti yako na jina ulilosajili FES – Usilitoe kwa yeyote.
        </div>
        <div style={{
          background: "#333", padding: "15px", borderRadius: "8px",
          boxShadow: "0 3px 6px rgba(0,0,0,0.3)"
        }}>
          💰 Fuatilia salio la faida na historia ya deposit/ushindi wako.
        </div>
        <div style={{
          background: "#333", padding: "15px", borderRadius: "8px",
          boxShadow: "0 3px 6px rgba(0,0,0,0.3)"
        }}>
          📊 Weka malengo yako ya kuwekeza na uone maendeleo kila wakati.
        </div>
        <div style={{
          background: "#333", padding: "15px", borderRadius: "8px",
          boxShadow: "0 3px 6px rgba(0,0,0,0.3)"
        }}>
          🚀 Pata mwongozo wa kuongeza faida na kushirikiana na wachezaji wengine.
        </div>
        <div style={{
          background: "#333", padding: "15px", borderRadius: "8px",
          boxShadow: "0 3px 6px rgba(0,0,0,0.3)"
        }}>
          🔗 Tumia kadi ya mwaliko (invite code & referral link) kuleta marafiki.
        </div>
        <div style={{
          background: "#333", padding: "15px", borderRadius: "8px",
          boxShadow: "0 3px 6px rgba(0,0,0,0.3)"
        }}>
          🛡️ Linda account yako, usitoe taarifa nyeti kwa wengine.
        </div>
        <div style={{
          background: "#333", padding: "15px", borderRadius: "8px",
          boxShadow: "0 3px 6px rgba(0,0,0,0.3)"
        }}>
          ⚠️ Uzembe unaweza kusababisha account kufungwa au kusimamishwa.
        </div>
      </div>

      {/* Progress tracker */}
      <div style={{ marginTop: "30px" }}>
        <p style={{ marginBottom: "5px" }}>📈 Progress yako ya kuwekeza:</p>
        <div style={{
          background: "#555", borderRadius: "8px", overflow: "hidden", height: "20px"
        }}>
          <div style={{
            width: "60%", background: "#4caf50", height: "100%", transition: "width 0.3s"
          }} />
        </div>
      </div>
    </div>
  );
};

export default ParcenalCenter;